/**
 * The sign-in illustration: events folding into a batch, a root, and a block.
 * Pure SVG in theme colours; drawn once, then it breathes gently (static when
 * reduced motion is preferred).
 */
export function ChainArt() {
  const leaves = [0, 1, 2, 3, 4, 5, 6, 7];
  return (
    <svg className="chain-art" viewBox="0 0 360 260" role="presentation">
      {/* leaves → pairs → root */}
      {leaves.map((i) => {
        const x = 24 + i * 44;
        const px = 46 + Math.floor(i / 2) * 88;
        return (
          <g key={i} className="chain-art__leaf" style={{ animationDelay: `${i * 90}ms` }}>
            <path d={`M${x + 12} 44 C ${x + 12} 70, ${px + 12} 70, ${px + 12} 96`} className="chain-art__edge" />
            <rect x={x} y={20} width={24} height={24} rx={6} className="chain-art__node" />
          </g>
        );
      })}
      {[0, 1, 2, 3].map((j) => {
        const x = 46 + j * 88;
        const qx = 90 + Math.floor(j / 2) * 176;
        return (
          <g key={j} className="chain-art__pair" style={{ animationDelay: `${700 + j * 110}ms` }}>
            <path d={`M${x + 12} 120 C ${x + 12} 140, ${qx + 12} 140, ${qx + 12} 160`} className="chain-art__edge" />
            <rect x={x} y={96} width={24} height={24} rx={6} className="chain-art__node chain-art__node--mid" />
          </g>
        );
      })}
      {[0, 1].map((k) => {
        const x = 90 + k * 176;
        return (
          <g key={k} className="chain-art__pair" style={{ animationDelay: `${1150 + k * 120}ms` }}>
            <path d={`M${x + 12} 184 C ${x + 12} 200, 180 196, 180 212`} className="chain-art__edge" />
            <rect x={x} y={160} width={24} height={24} rx={6} className="chain-art__node chain-art__node--mid" />
          </g>
        );
      })}
      <g className="chain-art__root">
        <rect x={150} y={212} width={60} height={34} rx={10} className="chain-art__block" />
        <path d="M168 229h24M176 222l-2 14M186 222l-2 14" className="chain-art__glyph" />
      </g>
    </svg>
  );
}
